import {
  REQUEST_COMPLETED_STATUS,
  REQUEST_DENIED_STATUS,
} from '../../../constants/request'

export const ATTACH_SERVICE_REQUESTS_SEARCH_MAX_LENGTH = 256

export const ATTACH_SERVICE_REQUESTS_NOTIFICATION_ID = {
  aiSuggest: 'ai-suggest',
  canSelectOneItem: 'can-select-one-item',
  limitExceeded: 'related-requests-limit-exceeded',
  limitInfo: 'related-requests-limit-info',
}

export const QA_NAME_ATTACH_SERVICE_REQUESTS_MODAL =
  'ServiceRequestsAttachModal'

export const QA_NAME_ATTACH_SERVICE_REQUESTS_AI_BUTTON =
  'attach_service_requests_ai_button'

export const QA_NAME_ATTACH_SERVICE_REQUESTS_AI_COLLAPSE_BUTTON =
  'attach_service_requests_ai_collapse_button'

export const QA_NAME_ATTACH_SERVICE_REQUESTS_AI_PANEL_ROW =
  'attach_service_requests_ai_panel_row'

export const QA_NAME_ATTACH_SERVICE_REQUESTS_AI_REFRESH_BUTTON =
  'attach_service_requests_ai_refresh_button'

export const AttachServiceRequestsAIConfidence = {
  High: 'high',
  Low: 'low',
  Medium: 'medium',
}

export const ATTACH_SERVICE_REQUESTS_AI_CONFIDENCE_CONFIG = {
  [AttachServiceRequestsAIConfidence.High]: {
    text: 'Modal.AttachServiceRequestsAIConfidenceHighKey',
    textColor: 'var(--color-success)',
  },
  [AttachServiceRequestsAIConfidence.Low]: {
    text: 'Modal.AttachServiceRequestsAIConfidenceLowKey',
    textColor: 'var(--secondary-text-color)',
  },
  [AttachServiceRequestsAIConfidence.Medium]: {
    text: 'Modal.AttachServiceRequestsAIConfidenceMediumKey',
    textColor: 'var(--color-in-progress)',
  },
}

export const ATTACH_SERVICE_REQUESTS_AI_REASON_KEY = {
  'Same address': 'Modal.AttachServiceRequestsAIReasonSameAddressKey',
  'Same owner': 'Modal.AttachServiceRequestsAIReasonSameOwnerKey',
  'Same problem': 'Modal.AttachServiceRequestsAIReasonSameProblemKey',
  'Same SR number': 'Modal.AttachServiceRequestsAIReasonSameSrNumberKey',
}

export const ATTACH_SERVICE_REQUESTS_MODAL_TABLE_CELL_NAME = {
  assignees: 'assignees',
  building: 'building',
  deadline: 'due_date',
  flat: 'flat',
  manager: 'owner',
  requestNo: 'request_no',
  status: 'status',
  title: 'title',
}

export const AttachServiceRequestsStatusAction = {
  ChangeStatus: 'changeStatus',
  Restore: 'restore',
}

export const ATTACH_SERVICE_REQUESTS_CLOSED_STATUSES = [
  REQUEST_COMPLETED_STATUS,
  REQUEST_DENIED_STATUS,
]

export const ATTACH_SERVICE_REQUESTS_PAGINATION_PAGE_SIZE_KEY = 'size'
